/*
 * Public API Surface of ngx-menu-float
 */

export * from './lib/ngx-menu-float.component';
export * from './lib/ngx-menu-float.module';
